import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryCards() {
  return (
    <section className="py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            内容分类
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            从多个维度深入剖析李宗瑞案件，选择您关注的方向进行阅读
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group block bg-background-100 rounded-lg p-6 border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 cursor-pointer hover:translate-y-[-2px]"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 dark:group-hover:text-foreground-950 transition-colors duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}